$(document).ready(function(){
  $(".icon.icon--list").click(function(){
      $(this).closest('.coll_itg').find('.touch-area').removeClass('is-selected');
      $(this).closest('.touch-area').addClass('is-selected');
      $(this).closest('.coll_itg').find('.grid__itg').removeClass('grid__item');
      $(this).closest('.coll_itg').find('.grid__itg').addClass('list__item');
  });

  $(".icon.icon--grid ").click(function(){
      $(this).closest('.coll_itg').find('.touch-area').removeClass('is-selected');
      $(this).closest('.touch-area').addClass('is-selected');
      $(this).closest('.coll_itg').find('.grid__itg').removeClass('list__item');
      $(this).closest('.coll_itg').find('.grid__itg').addClass('grid__item');
  });
  
  // $("#predictive-search-results").addClass('page-width');


  $(".unformatted.options li a").on('click', function(){
    var op_txt = $(this).text();
    var op_url = $(this).attr('rel');
    $(this).closest('details').find(".styledSelect").text(op_txt);
    $(this).closest('.event-calender').find(".advanced").attr('href', op_url);
    $(this).closest('details').removeAttr('open');
    // alert(op_url);
  });


    $(".collection-sort__label.SortTags").click(function(){
    if ($('ul#SortTags.collection-sort__input').hasClass('act')) {
      $('ul#SortTags.collection-sort__input').removeClass('act');
    }else{
      $('ul#SortTags.collection-sort__input').addClass('act');
    }
  });


   function itgFilter(){
     var collection_url = $(document).find('.itg_filter_mndv').attr('data-url');
      var tag_list = '/';
       $(document).find('ul.itg_collection_sort li.active_box').each(function(index){
        if(index == 0){
          tag_list += $(this).attr('value');        	
        }else{
          tag_list += '+'+$(this).attr('value');
        }
     });
      collection_url +=tag_list;
      var searchParams = new URLSearchParams(window.location.search);
      var sort_by_data = searchParams.get('sort_by');
      if(sort_by_data == null){
        var obj = { Title: 'ChangeUrl', Url: collection_url };  
        history.pushState(obj, obj.Title, obj.Url);
        location.reload();
      }else{
         var obj = { Title: 'ChangeUrl', Url: collection_url+'?sort_by='+sort_by_data };  
    	 history.pushState(obj, obj.Title, obj.Url);
         location.reload();
      }
      
   }
  
   $(document).on('click','ul.itg_collection_sort li',function(e){
       if( $(this).hasClass('active_box')){
    	 $(this).removeClass('active_box');
       }else{    	
         $(this).addClass('active_box');
      }
      itgFilter();
   });

  // subcollection slider
  $('.owl-carousel').owlCarousel({
    // center: true,
    loop:false,
    margin:10,
    items:5,
    nav:false,
    dots:false,
    responsive:{
        0:{
            items:2
        },
        600:{
            items:3
        },
        900:{
            items:4
        },
        1025:{
            items:5
        },
     }
  });

  $("#myInput").on("keyup", function() {
    var value = this.value.toLowerCase().trim();
    $("#more-filters li").show().filter(function() {
      return $(this).attr('data-find').toLowerCase().trim().indexOf(value) == -1;
    }).hide();
  });


  function itgLoopFor() {
   
    if($("._ls_bs").hasClass("ls-filter-collection")) {
       // console.log('1');
      var titleCheck = $(document).find('#_ls_filter_sidebar');
      if (titleCheck.length) {
        // console.log("find");
        if (titleCheck.hasClass('itg-chngd')) {
          // console.log('added');
        } else {
           // console.log('add');
          // titleCheck.closest('.slick-slide').css('display', 'none');
          titleCheck.addClass('itg-chngd');
          titleCheck.closest('.ls-filter-collection').find('#_ls_filter_sidebar_show').trigger( "click" );
          // titleCheck.css('display', 'none');
          // titleCheck.closest('.satcb-cs-upsell-item-btn').append('<a class="satcb-cs-item-atc_itg" href="https://www.heathrilesbbq.com/pages/bundle" data-product="" tabindex="0">view product</a>');
        }
      }
    }
  }

  var bundle = setInterval(itgLoopFor, 1000);

  // var this_v = $('.select-option-ls select option:selected').val();
  // var variant_price = $('.hidden_ls-variant option[data-title="'+this_v+'"]').data('price');
  // $(this).closest('.ls-thumbnail').find('.ls-lead').text(variant_price);
  setTimeout(function(){
  $(document).on('each','.select-option-ls select option',function() {
    var this_v =  $(this).val();
        console.log(this_v);
    // var variant_id = $('.hidden_ls-variant option[data-title="'+this_v+'"]').val();
    // var variant_price = $('.hidden_ls-variant option[data-title="'+this_v+'"]').data('price');
    // console.log(variant_price);
    // var sold_out = $('.hidden_ls-variant option[data-title="'+this_v+'"]').attr('disabled');
    // $(this).closest('.ls-thumbnail').find('.ls-lead').text(variant_price);
    // $(this).closest('.ls-thumbnail').find('.form input[name="id"]').val(variant_id);
    // if(sold_out){
    //   $(this).closest('.ls-thumbnail').find('.form .quick-add__submit').addClass('disabled_cart');
    // }else{
    //  $(this).closest('.ls-thumbnail').find('.form .quick-add__submit').removeClass('disabled_cart');
    // }
  });
   },9000);
  $(document).on('change','.select-option-ls select',function() {
    var this_v =  $(this).val();
    var variant_id = $('.hidden_ls-variant option[data-title="'+this_v+'"]').val();
    var variant_price = $('.hidden_ls-variant option[data-title="'+this_v+'"]').data('price');
    var sold_out = $('.hidden_ls-variant option[data-title="'+this_v+'"]').attr('disabled');
    $(this).closest('.ls-thumbnail').find('.ls-lead').text(variant_price);
    $(this).closest('.ls-thumbnail').find('.form input[name="id"]').val(variant_id);
    if(sold_out){
      $(this).closest('.ls-thumbnail').find('.form .quick-add__submit').addClass('disabled_cart');
    }else{
     $(this).closest('.ls-thumbnail').find('.form .quick-add__submit').removeClass('disabled_cart');
    }
  });
     
  $(document).on('change','.card_variant-option select',function() {
    var this_v =  $(this).val();
    var variant_id = $('.select_hidden option[data-title="'+this_v+'"]').val();
    var variant_price = $('.select_hidden option[data-title="'+this_v+'"]').data('price');
    var sold_out = $('.select_hidden option[data-title="'+this_v+'"]').attr('disabled');
    $(this).closest('.card__content').find('.price-item--regular').text(variant_price);
    $(this).closest('.card__content').find('.form input[name="id"]').val(variant_id);
    if(sold_out){
      $(this).closest('.card__content').find('.form .quick-add__submit').addClass('disabled_cart');
    }else{
     $(this).closest('.card__content').find('.form .quick-add__submit').removeClass('disabled_cart');
    }
  });

  // $(document).on('click','.quick-add__submit',function(event){
  //   event.preventDefault();
  //   var variandId = $('input[name="id"]').val();
  //   console.log(variandId);
  // });
});


